import React, { useState, useEffect } from 'react';
import './App.css';
import Mapper from './mapper';
import Areas from './static/areas.json';
import initial from './static/checklists/initial.json';
import pre_start from './static/checklists/pre-start.json';
import starting from './static/checklists/starting.json'
import taxyAndEngineTest from './static/checklists/taxy_and_engine_check.json'
import takeOff from './static/checklists/take-off.json'
import duringTakeOff from './static/checklists/during-take-off.json'
import afterTakeOff from './static/checklists/after-take-off.json'
import mantac from './static/checklists/mantac.json'
import feel from './static/checklists/feel.json'
import hasell from './static/checklists/hasell.json'
import fireass from './static/checklists/fireaas.json'
import landing from './static/checklists/landing.json'
import afterLanding from './static/checklists/after-landing-shutdown.json'
import ChecklistArea from './checklistArea';
import MenuScreen from './menu';
import TextInputPopup from './textPopup';

function App() {
  const checklists = [initial, pre_start, starting, taxyAndEngineTest, 
    takeOff, duringTakeOff, afterTakeOff, mantac, feel, hasell, fireass, landing, afterLanding];
  const checklistTitles = checklists.map(cl => cl.title);

  const [checklist, setChecklist] = useState(null);
  const [areas, setAreas] = useState(Areas);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentScreen, setCurrentScreen] = useState('menu');
  const [showTextInput, setShowTextInput] = useState(false);
  const [answerAccuracies, setAnswerAccuracies] = useState([]);
  const [checklistComplete, setChecklistComplete] = useState(false);
  const [cockpitSelection, setCockpitSelection] = useState(null);

  // Update pre-fill color of a specific area
  const updatePreFillColor = (nameToUpdate) => {
    setAreas(prevAreas =>
      prevAreas.map(area =>
        area.title === nameToUpdate ? { ...area, preFillColor: "#3fbc5969" } : area
      )
    );
  };

  // Clear all pre-fill colors
  const clearAllPreFillColors = () => {
    setAreas(prevAreas =>
      prevAreas.map(area => ({ ...area, preFillColor: "" }))
    );
  };

  // Increment the current index
  const bumpCurrentIndex = (amount) => {
    setCurrentIndex(prevIndex => prevIndex + amount);
  };

  // Handle cockpit selection
  const onChange = (selectedArea) => {
    setCockpitSelection(selectedArea);
    bumpCurrentIndex(1);
  };

  // Handle starting the app with a selected checklist
  const onStartApp = (checklistTitle) => {
    const selectedChecklist = checklists.find(cl => cl.title === checklistTitle);
    setChecklist(selectedChecklist);
  };

  // Update pre-fill color and handle subheading skipping after the current index changes
  useEffect(() => {
    if (checklist === null) return;

    const currentItem = checklist.items[currentIndex];

    if (currentItem?.cockpitRef) {
      updatePreFillColor(currentItem.cockpitRef);
      setAnswerAccuracies(prevItems => [...prevItems, (currentItem.cockpitRef === cockpitSelection.title)])
    } else if (currentItem.type === "subheading") {
      setAnswerAccuracies(prevItems => [...prevItems, null])
    } else {
      setAnswerAccuracies(prevItems => [...prevItems, currentItem.possibleAnswers.includes(cockpitSelection)])
    }

    if (currentIndex +1 >= checklist.items.length) {
      clearAllPreFillColors()
      setChecklistComplete(true)
      return
    }

    const nextItem = checklist.items[currentIndex + 1];
    if (nextItem?.type === "subheading") {
      setCurrentIndex(prev => prev + 1); // Skip subheading
    } else if (nextItem.cockpitRef === null) {
      setShowTextInput(true)
    }

  }, [currentIndex, checklist, cockpitSelection]);

  // Handle mouse move event
  const onMouseMove = () => {
    clearAllPreFillColors();
  };

  // Update current screen when checklist is set
  useEffect(() => {
    if (checklist) {
      setCurrentScreen('app');
    }
  }, [checklist]);

  useEffect(() => {
    if (currentScreen === 'menu') {
      setCurrentIndex(0)
      setChecklistComplete(false);
    }
  }, [currentScreen])

  const onExit = () => {
    setCurrentScreen('menu')
    setAnswerAccuracies([])
    setChecklist(null)
  }

  const onCloseTextInput = () => {
    setShowTextInput(false)
    clearAllPreFillColors()
  }

  return (
    currentScreen === 'menu' ? (
      <MenuScreen onStart={onStartApp} checklistTitles={checklistTitles} />
    ) : (
      <div className="app-container">
        <ChecklistArea 
          title={checklist.title} 
          items={checklist.items}
          currentIndex={currentIndex}
          answerAccuracies={answerAccuracies}
          onExit={onExit} 
          isComplete={checklistComplete}
        />
        <div className="mapper-panel">
          <Mapper 
            isDisabled={checklistComplete} 
            onChange={onChange} 
            areas={areas} 
            onMouseMove={onMouseMove} 
          />
        </div>
        < TextInputPopup isOpen={showTextInput} onSubmit={onChange} onClose={onCloseTextInput}></TextInputPopup>
      </div>
    )  
  );
}

export default App;
